module.exports = __webpack_public_path__ + "static/media/radio200x200.896e80bc.jpg";